<pp-modal
  [ppNoFooter]="step === 'select' && !importingCustomFields"
  [ppScrollOnDefault]="true"
  [ppScrollX]="maxListDepthExceeded"
  [ppNoPadding]="true"
  [ppWidth]="'653px'"
>
  <ng-container heading>
    {{ 'create_custom_field' | ppTranslate }}
  </ng-container>

  <ng-container body>
    <section class="modalContent" [class.modalContent--hidden]="showingFormulaError">
      @if (step !== 'details') {
        <pp-double-select
          [ppFirstOption]="'add_new_cf_capital' | ppTranslate"
          [ppSecondOption]="'import_cf_capital' | ppTranslate"
          (ppFirstChoice)="toggleImport(false)"
          (ppSecondChoice)="toggleImport(true)"
          [ppSelected]="importingCustomFields ? 1 : 0"
          class="hideMobile"
        ></pp-double-select>
      }

      @if (!importingCustomFields) {
        <div class="newCFModal">
          @if (step === 'select') {
            <div class="newCFModal__header">
              <h5 class="addCF__field-label modal__body-title">
                {{ 'choose_type' | ppTranslate }}
              </h5>
              <div class="addCF__grid-wrapper">
                @for (customField of customFieldTypesData; track customField) {
                  <pp-custom-field-tile-small
                    ppTooltip
                    [ppImage]="customField.iconPath"
                    [ppText]="customField.text"
                    [ppDisabled]="
                      (customField.value === customFieldTypes.TIMELINE && timelineExists) ||
                      (!timelineEnabled && customField.value === customFieldTypes.TIMELINE)
                    "
                    [ppTitle]="
                      customField.value === customFieldTypes.TIMELINE && timelineExists
                        ? ('prompt_field_create_error_timeline_doubled' | ppTranslate)
                        : !timelineEnabled && customField.value === customFieldTypes.TIMELINE
                          ? ('enable_timeline' | ppTranslate)
                          : ''
                    "
                    (ppOnSelect)="setType(customField.value)"
                  ></pp-custom-field-tile-small>
                }
                @if (integrationsVisible) {
                  <pp-custom-field-tile-small
                    [ppImage]="EIconPath.ICON_INTEGRATION_VOLY_LOGO_24"
                    [ppText]="'voly_integration' | ppTranslate"
                    (ppOnSelect)="navToInt()"
                  ></pp-custom-field-tile-small>
                }
              </div>
            </div>
          }
          @if (
            step === 'details' &&
            field.type === customFieldTypes.LIST &&
            workspace.share.shareOption === EUserRole.OWNER
          ) {
            <pp-button ppStyle="primary" ppSize="small">
              <label class="settingsNewSite__upload-button" for="excel">
                {{ 'create_list_from_excel' | ppTranslate }}
              </label>
              <pp-upload
                id="excel--update"
                [ppId]="'excel'"
                (ppUpload)="uploadExcel($event, customFieldTypes.LIST)"
                [ppDisabled]="false"
              >
              </pp-upload>
            </pp-button>
          }
          @if (
            step === 'details' &&
            field.type === customFieldTypes.MULTI_LIST &&
            workspace.share.shareOption === EUserRole.OWNER
          ) {
            <pp-create-multi-list-from-excel-button
              (ppAction)="uploadExcel($event, customFieldTypes.MULTI_LIST)"
            ></pp-create-multi-list-from-excel-button>
          }
          @if (step === 'details') {
            <pp-edit-custom-field-details
              [(ppCustomField)]="field"
              (ppGoBack)="back()"
              [ppWorkspaceId]="workspaceId"
              (ppListError)="updateListError($event)"
              [ppCustomFieldGroupOptions]="customFieldGroupOptions"
            ></pp-edit-custom-field-details>
          }
        </div>
      }

      @if (importingCustomFields) {
        <div class="newCFModal">
          @if (customFieldGroupsEnabled) {
            <pp-add-custom-field-groups-import
              [ppWorkspaceId]="workspaceId"
              [ppTargetGroupId]="preselectedGroupId"
              (ppSelectionChange)="updateCustomFieldGroupsSelection($event)"
              (ppFormulaFieldsMissingOperands)="updateFormulaFieldsMissingOperands($event)"
              (ppExistingGroupNames)="updateExistingGroupNames($event)"
            ></pp-add-custom-field-groups-import>
          } @else {
            <pp-add-custom-field-modal-import
              [ppSelectedCustomFields]="selectedCustomFields"
              [ppProcessingImport]="processingImport"
              [ppTotalSelectedFields]="totalSelectedFields"
              [ppTimelineExists]="timelineExists"
              [ppTimelineEnabled]="timelineEnabled"
            ></pp-add-custom-field-modal-import>
          }
        </div>
      }
    </section>

    @if (showingFormulaError) {
      <pp-add-custom-field-modal-import-formula-error></pp-add-custom-field-modal-import-formula-error>
    }
  </ng-container>

  <ng-container footer>
    @if (!importingCustomFields && step !== 'select') {
      <pp-modal-generic-footer
        [ppConfirmText]="'create' | ppTranslate"
        [ppProcess]="processing || processingImport"
        (ppCancel)="hideModal()"
        (ppConfirm)="save()"
        [ppDisabled]="checkSaveButtonDisabled()"
      ></pp-modal-generic-footer>
    }

    @if (importingCustomFields && !showingFormulaError) {
      <div class="newCFModal__importCFGroups">
        @if (customFieldGroupsEnabled && importErrorMessage) {
          <p class="newCFModal__import newCFModal__import--error" data-test="importError">
            {{ importErrorMessage }}
          </p>
        }

        @if (customFieldGroupsEnabled && formulaFieldsMissingOperands.length > 0) {
          <p
            class="newCFModal__import newCFModal__import--error"
            data-test="formulaOperandsMissing"
          >
            <pp-icon ppClass="setSize18" [ppSVG]="iconMap[EIconPath.ICON_BADGE_INFO]" />
            <span>{{ getFormulaOperandsMissingMessage() }}</span>
          </p>
        }

        @if (customFieldGroupsEnabled && existingGroupNames.length > 0) {
          <p class="newCFModal__import newCFModal__import--warning" data-test="existingGroupNames">
            <pp-icon ppClass="setSize18" [ppSVG]="iconMap[EIconPath.ICON_BADGE_WARNING_18]" />
            <span>{{ getExistingGroupsMessage() }}</span>
          </p>
        }

        <pp-modal-generic-footer
          [ppConfirmText]="getImportButtonText()"
          [ppProcess]="processing || processingImport"
          (ppCancel)="hideModal()"
          (ppConfirm)="importCustomFields()"
          [ppDisabled]="checkImportButtonDisabled()"
        ></pp-modal-generic-footer>
      </div>
    }

    @if (showingFormulaError) {
      <pp-modal-generic-footer
        [ppConfirmText]="'ok' | ppTranslate"
        [ppHideCancel]="true"
        (ppConfirm)="toggleFormulaErrorModal(false)"
      ></pp-modal-generic-footer>
    }
  </ng-container>
</pp-modal>
